import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { App } from './App';
import './styles/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 },
    mutations: { retry: 0 },
  },
});

// â”€â”€ EasyCart SSO: ingest token from URL before rendering â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// When EasyCart opens POS via: window.open(`${POS_URL}?token=<jwt>`)
// we grab it here, exchange it for a full POS session, then clean the URL.
async function initSso(): Promise<void> {
  const params   = new URLSearchParams(window.location.search);
  const ssoToken = params.get('token');
  if (!ssoToken) return;

  // Clean the token from the URL immediately (don't expose it in history)
  window.history.replaceState({}, '', window.location.pathname);

  try {
    // Dynamically import to avoid circular dep with store
    const { api } = await import('./api/client');
    const { useAuthStore } = await import('./store/auth');

    const { data } = await api.post('/auth/sso', { token: ssoToken });

    // Populate POS auth store â€” user is now fully authenticated
    useAuthStore.getState().setAuth(data.user, data.accessToken, data.refreshToken);

    console.log('[SSO] EasyCart login accepted â€” welcome to POS,', data.user.fullName);
  } catch (err) {
    console.warn('[SSO] Token exchange failed:', err);
    // Non-fatal: falls back to normal login page
  }
}

// Run SSO init before React renders (synchronously blocks render until done)
initSso().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename="/omniretail" future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <App />
          <Toaster position="top-right" />
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>
  );
});
